export default "__VITE_ASSET__BuKoXl$v__"